import React from "react";
import NavLazyImage from "../nav-lazy-image";
var AppPopover = function AppPopover(_ref) {
  var isMount = _ref.isMount,
    image = _ref.image;
  return /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-right-popover app-download'
  }, /*#__PURE__*/React.createElement("h3", null, "\u4E0B\u8F098891APP"), /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 608,
    height: 201,
    loaded: isMount,
    className: 'app-download-banner',
    src: "".concat(image, "/header/img-1.png"),
    alt: "\u4E0B\u8F098891APP"
  }), /*#__PURE__*/React.createElement("h3", null, "\u6578\u5B57APP"), /*#__PURE__*/React.createElement("ul", {
    className: 'app-download-list'
  }, /*#__PURE__*/React.createElement("li", {
    className: 'app-download-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.8591.com.tw/news-app.html?aid=849',
    target: '_blank',
    title: "8591\u5BF6\u7269\u4EA4\u6613",
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    src: "".concat(image, "/header/icon-8591.png"),
    alt: "8591\u5BF6\u7269\u4EA4\u6613"
  }), /*#__PURE__*/React.createElement("p", null, "8591\u5BF6\u7269\u4EA4\u6613"))), /*#__PURE__*/React.createElement("li", {
    className: 'app-download-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.591.com.tw#anchor_app',
    target: '_blank',
    title: "591\u623F\u5C4B\u4EA4\u6613",
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    src: "".concat(image, "/header/icon-591.png"),
    alt: "591\u623F\u5C4B\u4EA4\u6613"
  }), /*#__PURE__*/React.createElement("p", null, "591\u623F\u5C4B\u4EA4\u6613"))), /*#__PURE__*/React.createElement("li", {
    className: 'app-download-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.8891.com.tw/#eight_carousel",
    target: '_blank',
    title: "8891\u65B0\u8ECA",
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    src: "".concat(image, "/header/icon-8891-newCar.png"),
    alt: "8891\u65B0\u8ECA"
  }), /*#__PURE__*/React.createElement("p", null, "8891\u6C7D\u8ECA"))), /*#__PURE__*/React.createElement("li", {
    className: 'app-download-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.8891.com.tw/index-appDown.html',
    target: '_blank',
    title: "8891\u6C7D\u8ECA\u4EA4\u6613",
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    src: "".concat(image, "/header/icon-8891.png"),
    alt: "8891\u6C7D\u8ECA\u4EA4\u6613"
  }), /*#__PURE__*/React.createElement("p", null, "8891\u4E2D\u53E4\u8ECA"))), /*#__PURE__*/React.createElement("li", {
    className: 'app-download-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://uc.100.com.tw/apps-download.html',
    target: '_blank',
    title: "100\u5BA4\u5167\u8A2D\u8A08",
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    src: "".concat(image, "/header/icon-100.png"),
    alt: "100\u5BA4\u5167\u8A2D\u8A08"
  }), /*#__PURE__*/React.createElement("p", null, "100\u5BA4\u5167\u8A2D\u8A08"))), /*#__PURE__*/React.createElement("li", {
    className: 'app-download-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.518.com.tw/',
    target: '_blank',
    title: "518 \u718A\u73ED",
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    src: "".concat(image, "/header/ic_bearworks_job.svg"),
    alt: "518 \u718A\u73ED"
  }), /*#__PURE__*/React.createElement("p", null, "518 \u718A\u73ED"))), /*#__PURE__*/React.createElement("li", {
    className: 'app-download-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.tasker.com.tw',
    target: '_blank',
    title: "\u51FA\u4EFB\u52D9",
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    src: "https://photo.8891.com.tw/2024/06/20/1718850537681618.png",
    alt: "\u51FA\u4EFB\u52D9"
  }), /*#__PURE__*/React.createElement("p", null, "\u51FA\u4EFB\u52D9"))), /*#__PURE__*/React.createElement("li", {
    className: 'app-download-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://518.com.tw/15043',
    target: '_blank',
    title: "\u5C0F\u96DE\u4E0A\u5DE5",
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    src: "".concat(image, "/header/icon-xiaoji.png"),
    alt: "\u5C0F\u96DE\u4E0A\u5DE5"
  }), /*#__PURE__*/React.createElement("p", null, "\u5C0F\u96DE\u4E0A\u5DE5"))), /*#__PURE__*/React.createElement("li", {
    className: 'app-download-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: 'https://www.945.com.tw/',
    target: '_blank',
    title: "\u627E\u5E2B\u5085",
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement(NavLazyImage, {
    width: 60,
    height: 60,
    loaded: isMount,
    src: "https://photo.8891.com.tw/2024/06/20/1718850541564406.png",
    alt: "\u627E\u5E2B\u5085"
  }), /*#__PURE__*/React.createElement("p", null, "\u627E\u5E2B\u5085")))));
};
export default AppPopover;